import { useEffect } from "react";
import socket from "../context/socket";
import { useLocation } from "react-router-dom";

export const useScrollSync = (role) => {
    const roomId = new URLSearchParams(useLocation().search).get("clientId");

    useEffect(() => {
        if (!socket) return;

        const handleScroll = (e) => {
            const target = e?.target;
            const mfrBody = document.querySelector(".mfr-body");
            const modalOpen = document.querySelector(".modal.show");

            const isModal = Boolean(
                (target && target !== document && target !== window && (
                    target.classList?.contains("modal") ||
                    target.classList?.contains("mfr-body") ||
                    (target.closest && target.closest(".modal"))
                )) ||
                (modalOpen && (target === mfrBody || target === modalOpen))
            );

            let scrollPosition;
            if (isModal) {
                scrollPosition = (target && typeof target.scrollTop === "number" && target.scrollTop >= 0)
                    ? target.scrollTop
                    : (mfrBody?.scrollTop || modalOpen?.scrollTop || 0);
            } else {
                scrollPosition = window.scrollY;
            }

            socket.emit("join", { room: roomId });
            socket.emit("scroll-update", { room: roomId, role, scrollPosition, isModal });
        };

        // Send scroll updates only if advisor (use capture: true for modal scrolls)
        if (role === "advisor") {
            window.addEventListener("scroll", handleScroll, true);
        }

        // Listen to scroll updates (for both sides)
        socket.on("scroll-update", (data) => {
            if (data?.role !== role) {
                if (data?.isModal) {
                    const mfrBody = document.querySelector(".mfr-body");
                    if (mfrBody) {
                        mfrBody.scrollTop = data.scrollPosition;
                    }
                    const modal = document.querySelector(".modal.show") || document.querySelector(".modal");
                    if (modal) {
                        modal.scrollTop = data.scrollPosition;
                    }
                } else {
                    window.scrollTo({
                        top: data?.scrollPosition,
                        behavior: "smooth",
                    });
                }
            }
        });

        return () => {
            window.removeEventListener("scroll", handleScroll, true);
            socket.off("scroll-update");
        };
    }, [role, roomId]);
};
